export default "Aides Copropriétés — MaPrimeRénov' Copro, CEE collectifs, Éco-PTZ | Solution Éco France";
